import { render } from "./detail.vue?vue&type=template&id=10a2a989&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=10a2a989&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a2a989"],['__file',"src/views/order/apartment/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10a2a989"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10a2a989', __exports__)) {
    console.log('reload')
    api.reload('10a2a989', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=10a2a989&scoped=true", () => {
    console.log('re-render')
    api.rerender('10a2a989', render)
  })

}


export default __exports__